import { productToDisableRenewButton } from './productToDisableRenewButton';

export const maskState = (productAnalyze, modalityAnalyze, state, risks = null) =>
  productToDisableRenewButton(productAnalyze, modalityAnalyze, risks) ? 'managerenewal' : state;
